import { render, staticRenderFns } from "./SysUserActiveModal.vue?vue&type=template&id=07d45204&"
import script from "./SysUserActiveModal.vue?vue&type=script&lang=js&"
export * from "./SysUserActiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports